import { useEffect } from 'react'
import { AddSearchSearchResultsProps } from '../types'
import styles from './styles.module.scss'
import {
  TEMPLATE_SEARCHRESULTS,
  TEMPLATE_SEARCHRESULTS_NORESULTS,
  TEMPLATE_SEARCHRESULTS_TOTALCOUNT
} from '@components/Search/SearchResults/const'

const LOAD_MORE_TEMPLATE = `
  <div class="addsearch-loadmore">
  {{#if isLoading}}
    {{#gt totalHits 0}}
      <span>Loading more..</span>
    {{/gt}}
  {{else if hasMorePages}}
    {{#equals type "BUTTON"}}
      <button>Load more</button>
    {{/equals}}
    {{#equals type "INFINITE_SCROLL"}}
      <span class="loadmore-infinite-scroll"></span>
    {{/equals}}
  {{/if}}
  </div>
`

const FACETS_TEMPLATE = `
  <div class="addsearch-facets" style="{{#unless facets }}display: none;{{/unless}}">
    <ul>
      {{#each facets}}
        <li data-facet="{{value}}">
          <label>
            <input type="checkbox" value="{{value}}" /><span>{{value}}</span> <em>({{count}})</em>
          </label>
        </li>
      {{/each}}
    </ul>
  </div>
`

export function SearchResults(props: AddSearchSearchResultsProps) {
  useEffect(() => {
    if (props.uiInstance) {
      props.uiInstance.facets({
        containerId: 'facets',
        field: 'custom_fields.parent_colour',
        template: FACETS_TEMPLATE,
        sticky: true
      })

      props.uiInstance.searchResults({
        containerId: props.containerId,
        template: TEMPLATE_SEARCHRESULTS,
        template_noresults: TEMPLATE_SEARCHRESULTS_NORESULTS,
        template_resultcount: TEMPLATE_SEARCHRESULTS_TOTALCOUNT,
        client: props.client
      })
      props.uiInstance.loadMore({
        containerId: 'loadmore',
        type: 'BUTTON',
        infiniteScrollElement: window,
        template: LOAD_MORE_TEMPLATE
      })

      props.uiInstance.start()
    }
  }, [props])

  return (
    <>
      <div id="facets" className={styles.Facets}></div>
      <div
        id={props.containerId}
        className={`${styles.SearchResultsContainer}`}
      ></div>
      <div id="loadmore" className={styles.LoadMore}></div>
    </>
  )
}
